import request from '@/utils/request'

// 分页查询
export function fetchList (data) {
  return request.post('/pc/couponTransaction/page', data, {
    trim: true
  })
}

// 手动核销
export function manualUse (code) {
  return request.post(`/pc/couponTransaction/pay/${code}`)
}

// 软删除
export function deleteById (id) {
  return request.post(`/pc/couponTransaction/softDelete/${id}`)
}

// 批量软删除
export function deleteByIdInBatch (ids) {
  return request.get('/pc/couponTransaction/delete/batch', {
    params: {
      ids
    }
  })
}
